/*
 * One shared page-scroll lock for every modal, drawer, sheet and lightbox.
 *
 * Why it exists: components used to do   prev = body.overflow; body.overflow = "hidden"; ...; body.overflow = prev
 * on their own. When two overlap (drawer -> edit dialog -> confirm) the second one saves "hidden" as the
 * "previous" value and puts it back at the end, so the page stays locked for good. This keeps a count of who
 * holds the lock: the page is locked while the count is above zero and restored once, when it reaches zero.
 *
 *   useEffect(() => { if (!open) return undefined; return lockScroll(); }, [open]);
 */

let holders = 0;
let originalOverflow = "";

export const lockScroll = () => {
  if (typeof document === "undefined") return () => {};

  if (holders === 0) {
    const current = document.body.style.overflow;
    // a stale "hidden" left behind by something else is never worth restoring
    originalOverflow = current === "hidden" ? "" : current;
    document.body.style.overflow = "hidden";
  }
  holders += 1;

  let released = false;
  return () => {
    if (released) return; // releasing twice must not unlock someone else's hold
    released = true;
    holders = Math.max(0, holders - 1);
    if (holders === 0) document.body.style.overflow = originalOverflow;
  };
};

export const isScrollLocked = () => holders > 0;

// Used by the watchdog (ScrollGuard): drop every hold and give the page back.
export const forceUnlockScroll = () => {
  holders = 0;
  if (typeof document !== "undefined") document.body.style.overflow = originalOverflow;
};
